/* Routes login */
export const login = "login";

/* Routes Patient */
export const patient = {
	api: {
		register: '/patient/register2',
		exists: '/patient/exists',
	}
};

/* Routes Doctor */
export const doctor = {
	register : "register/:source?",
	speciality: {
		list : '/specialities',
		listDoctor : '/doctor/specialities'
	},
	api: {
		bonus: '/doctor/bonus/',
		use_bonus: '/doctor/bonus',
		facebook: '/doctor/facebook',
		lang: {
			enabled: '/language',
			set: '/language/set',
			trans: '/language/translate'
		},
		register: '/doctor/register',
		exists: '/doctor/exists',
		upload: {
			avatar: '/doctor/avatar',
			office: '/doctor/upload/office',
			subordinate: '/doctor/upload/subordinate'
		},
		list: {
			doctor: '/doctor/doctor',
			office: '/doctor/offices'
		},
		patient: {
			exists: '/patient/exists',
		},
		diary: {
			store: '/diary',
			update: '/diary/'
		},
		comunities: '/doctor/comunities',
		regions: '/doctor/regions',
		offices: '/doctor/offices',
		schedules: '/doctor/schedules',
		turns: '/doctor/schedules/turn',
		extraHours: '/doctor/extra-hours',
		absences: '/doctor/absences',
		search: '/doctor/search',
		tracking: '/doctor/tracking',
		subordinates: '/doctor/subordinates',
		roles: '/doctor/roles',
		bids: '/doctor/bids',
		update_massive: '/doctor/update_massive',
		remove_presta: '/doctor/removeTask',
		medibox:{
			requests:'/medibox/requests'
		},
	}
};

/* Routes Public */
export const public_api = {
  api: {
    regions: '/regions',
    cities: '/cities',
    previsions: '/previsions',
    boxes: '/boxes',
    filter: {
      doctor: '/filter/doctor'
    },
    speciality: {
      list: '/specialities'
    },
    diary: {
      getHours: '/diary/getHoursAvailable'
    },
    patient: {
      store: '/patient/register2'
    }
  }
}

/* Routes Admin */
export const admin = {
    api: {

        countries: '/admin/countries',
				patients: '/doctor/patients/coords',
				companies: '/doctor/companies/coords',

        regions: '/doctor/regions',
				comunities: '/doctor/comunities',
				bonustask_types: '/admin/bonustasktypes'
    }
};
/* Prefix of countries enabled */
export const prefix = ['cl', 'pe', 'ar' ,'mx' ,'co' ,'es', 'us', 'bo' ,'do' ,'cr' ,'ve' ,'cu'];



// WEBPACK FOOTER //
// ./src/config/api.js